module.exports = __webpack_public_path__ + "img/operating_model.9ac9b2c6.png";